(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_accordion-row__details"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {

    // Listen for variant selector changes
    const variantSelectors = document.querySelectorAll('[name="id"], .variant-input, variant-picker, variant-picker select');

    variantSelectors.forEach(selector => {
      selector.addEventListener('change', function() {
        const variantId = this.value;
        updateProductDetails(variantId);
      });
    });

    // Also listen for custom events that might be fired by variant pickers
    document.addEventListener('variant:change', function(event) {
      if (event.detail && event.detail.variant) {
        updateProductDetails(event.detail.variant.id);
      }
    });

    // Listen for clicks on variant buttons/swatches
    document.addEventListener('click', function(event) {
      if (event.target.closest('[data-variant-id]')) {
        const variantId = event.target.closest('[data-variant-id]').getAttribute('data-variant-id');
        updateProductDetails(variantId);
      }
    });

    function updateProductDetails(variantId) {

      // Get variant data from the page
      const variantDataElement = document.querySelector('[data-variant-data]');
      if (! variantDataElement) return;
      


      try {
        const allVariants = JSON.parse(variantDataElement.textContent);
        const variant = allVariants.find(v => v.id == variantId);

        if (variant) {
          updateProductDetailsContent(variant);
        }
      } catch (error) {
        // Silent error handling
      }
    }

    function updateProductDetailsContent(variant) {

      // Find all product details blocks that should be updated
      const productDetailsBlocks = document.querySelectorAll('.product-details-block');

      productDetailsBlocks.forEach(block => {
        try {
          // Add loading state for screen readers
          block.setAttribute('aria-busy', 'true');
          
          let newContent = '';

          // Add fabric metafields if they exist and block is configured to show them
          const showFabric = block.hasAttribute('data-show-fabric');
          if (showFabric && variant.metafields && variant.metafields.custom && variant.metafields.custom.fabric) {
            const fabricValue = variant
              .metafields
              .custom
              .fabric
              .value;
            if (fabricValue) {
              const fabricLabel = block.getAttribute('data-fabric-label');
              const fabricFormat = block.getAttribute('data-fabric-format') || 'list';

              newContent += `<div class="product-details-block__fabric">`;
              if (fabricLabel) {
                newContent += `<p class="product-details-block__fabric-label">${fabricLabel}:</p>`;
              }

              // Safely handle fabric data - could be array, null, string, or JSON string
              if (fabricValue && fabricValue !== null) {
                let fabricItems = [];

              // Handle different fabric data types
                if (Array.isArray(fabricValue)) { // Already an array - use directly
                  fabricItems = fabricValue;
                } else if (typeof fabricValue === 'string') {
                  try { // Try to parse as JSON first
                    const parsed = JSON.parse(fabricValue);
                    if (Array.isArray(parsed)) {
                      fabricItems = parsed;
                    } else { // Single string value
                      fabricItems = [fabricValue];
                    }
                  } catch (e) { // Not JSON, treat as comma-separated string
                    fabricItems = fabricValue.split(',').map(item => item.trim()).filter(item => item.length > 0);
                  }
                } else { // Fallback - treat as single item
                  fabricItems = [String(fabricValue)];
                }

            // Generate the fabric content
                if (fabricItems.length > 0) {
                  if (fabricFormat === 'list') {
                    newContent += '<ul class="product-details-block__fabric-list">';
                    fabricItems.forEach(item => {
                      newContent += `<li>${item}</li>`;
                    });
                    newContent += '</ul>';
                  } else {
                    newContent += `<p class="product-details-block__fabric-text">${
                      fabricItems.join(', ')
                    }</p>`;
                  }
                }
              }
              newContent += '</div>';
            }
          }

          // Add weight if it exists and block is configured to show it
          const showWeight = block.hasAttribute('data-show-weight');
          if (showWeight && variant.weight && variant.weight > 0) {
            const weightLabel = block.getAttribute('data-weight-label');
            if (weightLabel) {
              newContent += `<p class="product-details-block__weight">${weightLabel}: ${
                variant.weight
              }</p>`;
            } else {
              newContent += `<p class="product-details-block__weight">${variant.weight}</p>`;
            }
          }

          // Add barcode if it exists and block is configured to show it
          const showBarcode = block.hasAttribute('data-show-barcode');
          if (showBarcode && variant.barcode) {
            const barcodeLabel = block.getAttribute('data-barcode-label');
            if (barcodeLabel) {
              newContent += `<p class="product-details-block__barcode">${barcodeLabel}: ${
                variant.barcode
              }</p>`;
            } else {
              newContent += `<p class="product-details-block__barcode">${variant.barcode}</p>`;
            }
          }

          // Add custom text (preserve static content)
          const customTextElement = block.querySelector('.product-details-block__text');
          if (customTextElement) {
            newContent += customTextElement.outerHTML;
          }

          // Add SKU at the bottom if it exists and block is configured to show it
          const showSku = block.hasAttribute('data-show-sku');
          if (showSku && variant.sku) {
            const skuLabel = block.getAttribute('data-sku-label');
            const trimmedSku = variant.sku.split('_')[0];
            if (skuLabel) {
              newContent += `<p class="product-details-block__sku">${skuLabel}: ${trimmedSku}</p>`;
            } else {
              newContent += `<p class="product-details-block__sku">${trimmedSku}</p>`;
            }
          }

          // Update the content
          block.innerHTML = newContent;
          
          // Remove loading state and announce update to screen readers
          block.setAttribute('aria-busy', 'false');
          block.setAttribute('aria-live', 'polite');
          
          // Announce the update to screen readers
          const announcement = `Product details updated for variant ${variant.sku || variant.id}`;
          const liveRegion = document.createElement('div');
          liveRegion.setAttribute('aria-live', 'polite');
          liveRegion.setAttribute('aria-atomic', 'true');
          liveRegion.className = 'sr-only';
          liveRegion.textContent = announcement;
          document.body.appendChild(liveRegion);
          
          // Remove the announcement after a short delay
          setTimeout(() => {
            if (liveRegion.parentNode) {
              liveRegion.parentNode.removeChild(liveRegion);
            }
          }, 1000);
          
        } catch (error) {
          // Remove loading state on error
          block.setAttribute('aria-busy', 'false');
        }
      });
    }
  });
  } catch(e) { console.error(e); }
})();

})();
